/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateTransactionSetupResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateTransactionSetupRequest, serializeCreateTransactionSetupResponse, type CreateTransactionSetupRequest, type CreateTransactionSetupResponse, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/worldpay/transaction-setup
 */
export interface TransactionSetupRequestBuilder extends BaseRequestBuilder<TransactionSetupRequestBuilder> {
    /**
     * Creates a WorldPay transaction setup and returns the hosted payment URL for the customer to complete payment details.
     * @param body Request to create a WorldPay transaction setup for hosted payments
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateTransactionSetupResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateTransactionSetupRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateTransactionSetupResponse | undefined>;
    /**
     * Creates a WorldPay transaction setup and returns the hosted payment URL for the customer to complete payment details.
     * @param body Request to create a WorldPay transaction setup for hosted payments
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateTransactionSetupRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TransactionSetupRequestBuilderUriTemplate = "{+baseurl}/api/payments/worldpay/transaction-setup";
/**
 * Metadata for all the requests in the request builder.
 */
export const TransactionSetupRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: TransactionSetupRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateTransactionSetupResponseFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateTransactionSetupRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
